import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e6ad2cf4")

_pushScopeId("data-v-e6ad2cf4")
const _hoisted_1 = {
  class: "section-proof section bg-white py-5",
  style: {"padding-top":"0 !important"}
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "testimonials container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Testimonial = _resolveComponent("Testimonial")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Pagination = _resolveComponent("Pagination")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Carousel, {
          "items-to-show": 1.4,
          "wrap-around": true
        }, {
          addons: _withId(() => [
            _createVNode(_component_Pagination)
          ]),
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testimonials, (t) => {
              return (_openBlock(), _createBlock(_component_Slide, {
                key: t.author
              }, {
                default: _withId(() => [
                  _createVNode(_component_Testimonial, {
                    class: "testimonial",
                    author: t.author,
                    body: t.body,
                    title: t.title,
                    "picture-url": t.pictureUrl,
                    type: t.type,
                    url: t.url
                  }, null, 8, ["author", "body", "title", "picture-url", "type", "url"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["items-to-show"])
      ])
    ])
  ]))
})